(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toworkfor-table-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-toworkfor]').forEach((content) => {
      const scrollbar = content.parentElement.querySelector('.scrollbar-x');

      if (!scrollbar) return;

      function updateScrollbar() {
        const maxScroll = content.scrollWidth - content.clientWidth;
        scrollbar.max = maxScroll;
      }

      scrollbar.addEventListener('input', function () {
        content.scrollLeft = scrollbar.value;
      });

      content.addEventListener('scroll', function () {
        scrollbar.value = content.scrollLeft;
      });

      window.addEventListener('resize', updateScrollbar);

      updateScrollbar();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
